/**
 * AdminClientesJugadoresBloqueoView — Web Component (Light DOM)
 *
 * Vista de Clientes del panel de administración.
 * Contiene dos tabs:
 *   - Jugadores: tabla de jugadores registrados con buscador fuzzy.
 *   - Bloqueos: tabla de bloqueos activos con creación de nuevos bloqueos.
 * Migrado desde index.html (sección Clientes).
 */
import { t } from '../../services/i18n-admin.js';
import { icon } from '../../utils/icon.js';

export class AdminClientesJugadoresBloqueoView extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
                    <!-- CLIENTES VIEW -->
                    <section class="view" id="view-clientes">
                        <div class="section-header">
                            <h3 class="section-title">${t('Clientes')}</h3>
                            <div class="view-tabs">
                                <button
                                    class="tab-btn active"
                                    data-tab="jugadores"
                                    data-action="app:switchTab"
                                    data-view="clientes"
                                >
                                    ${icon('users')} ${t('Jugadores')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="bloqueos"
                                    data-action="app:switchTab"
                                    data-view="clientes"
                                >
                                    ${icon('ban')} ${t('Bloqueos')}
                                </button>
                                <!-- Botón "Mostrar excluidos" — lo llena ClientesModule
                                     con el contador real (solo si hay excluidos). -->
                                <span id="clientes-btn-excluidos" style="margin-left:auto;"></span>
                            </div>
                        </div>

                        <!-- TAB: Jugadores — renderizado por ListadoConFiltrosYExport -->
                        <div class="tab-content active" id="tab-clientes-jugadores"></div>

                        <!-- TAB: Bloqueos -->
                        <div class="tab-content" id="tab-clientes-bloqueos" style="display: none">
                            <div class="table-container">
                                <div class="table-header">
                                    <h3>${t('Bloqueos Activos')}</h3>
                                    <button class="btn btn-primary" data-action="lotowheel:openBloqueoModal">
                                        ${icon('plus')}
                                        <span>${t('Nuevo Bloqueo')}</span>
                                    </button>
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>${t('Tipo')}</th>
                                            <th>${t('Identificador')}</th>
                                            <th>${t('Motivo')}</th>
                                            <th>${t('Notas')}</th>
                                            <th>${t('Fecha')}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody id="bloqueosTable"></tbody>
                                </table>
                            </div>
                        </div>
                    </section>
        `;
    }
}

customElements.define('admin-clientes-jugadores-bloqueo-view', AdminClientesJugadoresBloqueoView);
